import { DownloadIcon, SearchIcon, SortAscIcon, SortDescIcon } from '@primer/octicons-react';
import { ActionList, ActionMenu, Box, IconButton } from '@primer/react';
import { useContext, useMemo } from 'react';
import { useCommonContext } from '../../../contexts/common';
import Text from '../text';
import TextInput from '../text-input';
import { DataTableContainerContext, eSortMode, IColumn, IDataTableContext } from './DataTable';
import ExcelJS from "exceljs";
import { GetDataGridHederGroupCell, renderExcelHeader } from './DataTableHelper';


const Toolbar = () => {
    const { props, setSearchKey, sortConfig, setSortConfig, sortByField, filterdData } = useContext<IDataTableContext>(DataTableContainerContext);
    const { title, titleComponent, subTitle, subTitleComponent, actionComponent, searchEnable, columns, exportEnable } = props;
    const { translate } = useCommonContext();

    const sortByName = useMemo(() => {
        return props.columns
            .filter((x) => x.dataField === sortByField)
            .map((x) => x.caption)
            .join(",");
    }, [columns, sortByField]);
    const getDataColumns = () => {
        let result: any[] = [];
        columns.forEach((col) => {
            if ((col.columns ?? []).length === 0) {
                result.push(col);
            } else {
                setDataColumns(col, result);
            }
        });
        return result;
    };
    const setDataColumns = (col: IColumn, result: any[]) => {
        if ((col.columns ?? []).length === 0) {
            result.push(col);
        } else {
            (col.columns ?? []).forEach((sub) => {
                setDataColumns(sub, result)
            });
        }
    };
    const handleExport = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Sheet1");

        const headerGroups = GetDataGridHederGroupCell(columns);
        // debugger
        // console.log({
        //     headerGroups
        // });
        
        renderExcelHeader(worksheet, headerGroups);

        const dataStartRow = headerGroups.length + 1;

        const dataColumns = getDataColumns();
        // console.log({
        //     dataColumns
        // })



        dataColumns
            .forEach((col, idx) => {
                worksheet.getColumn(idx + 1).width = 15;
            });
        filterdData.forEach((item, idx) => {
            const rowValues = dataColumns
                .map((col) => (col.dataField ? item[col.dataField] : ""));
            worksheet.addRow(rowValues);
        });
        worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
            for (let col = 1; col <= worksheet.columnCount; col++) {
                const cell = row.getCell(col);

                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" },
                };

                if (rowNumber < dataStartRow) {
                    cell.font = { bold: true };
                }
            }
        });

        // Xuất file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/octet-stream" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `Download.xlsx`;
        link.click();
    }
    return (
        <Box id="toolbar" sx={{ display: "flex", mb: 1 }}>
            <Box
                id="left"
                sx={{
                    flex: 1,
                }}
            >
                {title && (
                    <Text
                        text={title}
                        sx={{
                            fontWeight: 600,
                            fontSize: 24,
                        }}
                    />
                )}
                {titleComponent && <Box>{titleComponent}</Box>}
                {(subTitle || subTitleComponent) &&
                    <Box>
                        {subTitle && <Text text={subTitle} sx={{
                            color: "fg.muted",
                            fontSize: "0.9rem"
                        }} />
                        }
                        {subTitleComponent && <>{subTitleComponent}</>}
                    </Box>
                }

            </Box>
            <Box
                id="actions"
                sx={{
                    display: "flex",
                    alignItems: "flex-start",
                }}
            >
                {actionComponent}
                {searchEnable && (
                    <Box sx={{ ml: 2 }}>
                        <TextInput
                            leadingVisual={SearchIcon}
                            placeholder={translate(`Search`)}
                            onValueDelayChanged={(value) => {
                                setSearchKey?.(value)
                            }}
                        ></TextInput>
                    </Box>
                )}
                {sortConfig && sortConfig.enable && (
                    <Box sx={{ ml: 2 }}>
                        <ActionMenu>
                            <ActionMenu.Button
                                leadingVisual={
                                    sortConfig?.mode === eSortMode.DESC
                                        ? SortDescIcon
                                        : SortAscIcon
                                }
                            >
                                Sắp xếp theo <b>{sortByName}</b>
                            </ActionMenu.Button>
                            <ActionMenu.Overlay>
                                <ActionList
                                    selectionVariant="single"
                                    role="menu"
                                    aria-label=""
                                >
                                    {props.columns
                                        .filter((x) => x.dataField)
                                        .map((x, idx) => {
                                            return (
                                                <ActionList.Item
                                                    key={idx}
                                                    role="menuitemcheckbox"
                                                    selected={x.dataField === sortConfig.field}
                                                    onSelect={() => {
                                                        if (sortConfig && setSortConfig)
                                                            setSortConfig({
                                                                ...sortConfig,
                                                                field: x.dataField ?? "",
                                                            });
                                                    }}
                                                >
                                                    {x.caption}
                                                </ActionList.Item>
                                            );
                                        })}

                                    <ActionList.Divider></ActionList.Divider>
                                    <ActionList.Item
                                        role="menuitemcheckbox"
                                        selected={sortConfig.mode === eSortMode.ASC}
                                        onSelect={() => {
                                            if (sortConfig && setSortConfig)
                                                setSortConfig({
                                                    ...sortConfig,
                                                    mode: eSortMode.ASC,
                                                });
                                        }}
                                    >
                                        <ActionList.LeadingVisual>
                                            <SortAscIcon />
                                        </ActionList.LeadingVisual>
                                        Ascending
                                    </ActionList.Item>
                                    <ActionList.Item
                                        role="menuitemcheckbox"
                                        selected={sortConfig.mode === eSortMode.DESC}
                                        onSelect={() => {
                                            if (sortConfig && setSortConfig)
                                                setSortConfig({
                                                    ...sortConfig,
                                                    mode: eSortMode.DESC,
                                                });
                                        }}
                                    >
                                        <ActionList.LeadingVisual>
                                            <SortDescIcon />
                                        </ActionList.LeadingVisual>
                                        Descending
                                    </ActionList.Item>
                                </ActionList>
                            </ActionMenu.Overlay>
                        </ActionMenu>
                    </Box>
                )}
                {exportEnable && (
                    <Box sx={{ ml: 2 }}>
                        <IconButton
                            icon={DownloadIcon}
                            variant="default"
                            aria-label="Download"
                            onClick={handleExport}
                        />
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default Toolbar;